export const POMODORO_POPUP_STATE_EVENT = 'pique-pomodoro-popup-state';
export const POMODORO_POPUP_ACTION_EVENT = 'pique-pomodoro-popup-action';

export type PomodoroPopupStatePayload = {
  itemId: string;
  title: string;
  pageId?: string;
  plannedDuration?: number;
  focusDaily?: Record<string, number>;
  focusTimeSeconds?: number | string;
  focusedSessionStartedAtMs?: number | null;
  isActive: boolean;
};

export type PomodoroPopupActionPayload =
  | { type: 'toggle'; itemId: string; isActive: boolean }
  | { type: 'open'; itemId: string; pageId?: string }
  | { type: 'minimize' }
  | { type: 'complete'; itemId: string };
